import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { NguoiYeuCauService } from '../services/nguoi-yeu-cau.service';

@Component({
  selector: 'app-nguoi-yeu-cau',
  templateUrl: './nguoi-yeu-cau.component.html',
  styleUrls: ['./nguoi-yeu-cau.component.css']
})
export class NguoiYeuCauComponent implements OnInit {
  data: any;
  loading = false;
  position = 'top';
  totalRecords: number;
  pageSize = 10;
  pageNumber = 0;
  infoFormGroup: FormGroup;
  nguoiYeuCauFlag = false;
  // searchValue = '';
  searchForm: FormGroup;
  constructor(private nguoiYeuCauService: NguoiYeuCauService,
    private router: Router, private message: MessageService) {
    this.searchForm = new FormGroup({
      searchValue: new FormControl('')
    });
    this.totalRecords = 0;
    this.searchForm.controls.searchValue.setValue('');
    this.infoFormGroup = new FormGroup({
      id: new FormControl(0),
      benthamgia: new FormControl('', [Validators.required, Validators.minLength(4)]),
      diachi: new FormControl('', [Validators.required, Validators.minLength(4)])
    });
  }

  getNYC(event: LazyLoadEvent) {
    this.loading = true;
    //event.rows

    if (event.rows != null) {
      this.pageSize = event.rows;
    }
    else {
      this.pageSize = 10;
    }
    this.nguoiYeuCauService.count(this.searchForm.controls.searchValue.value).subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.totalRecords = resp;
          // this.pageNumber = 0;
          let pageCurrent = 0;
          if (event.first != null && event.first != undefined) {
            pageCurrent = event.first / this.pageSize;
          }
          else {
            pageCurrent = 0;
          }
          this.nguoiYeuCauService.findNYC(this.searchForm.controls.searchValue.value, this.pageSize, pageCurrent).subscribe(
            (res: any) => {
              this.data = res;
              this.loading = false;
            }
          );
        }
      }
    );
  }

  ngOnInit(): void {
  }

  action() {
    if (this.infoFormGroup.valid) {
      this.nguoiYeuCauFlag = !this.nguoiYeuCauFlag;
      if (this.infoFormGroup.controls.id.value != undefined && this.infoFormGroup.controls.id.value > 0) {
        // Update
        const dataPost = {
          id: this.infoFormGroup.controls.id.value,
          benthamgia: this.infoFormGroup.controls.benthamgia.value,
          diachi: this.infoFormGroup.controls.diachi.value,
        };
        //console.log(dataPost);
        this.nguoiYeuCauService.update(this.infoFormGroup.controls.id.value, dataPost).subscribe(
          (resp: any) => {
            if (resp == null) {
              this.message.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã cập nhật thành công!' });
              this.getAllNYC();
              this.infoFormGroup.reset();
            }
            else {
              this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi cập nhật!' });
            }
          }
        );
      }
      else {
        // Add
        const dataPost = {
          benthamgia: this.infoFormGroup.controls.benthamgia.value,
          diachi: this.infoFormGroup.controls.diachi.value,
        };
        this.nguoiYeuCauService.add(dataPost).subscribe(
          (resp: any) => {
            if (resp.id != undefined) {
              this.message.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã thêm thành công!' });
              this.getAllNYC();
              this.infoFormGroup.reset();
            }
            else {
              this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi thêm!' });
            }
          }
        );
      }
    }
    else {
      this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn chưa nhập đủ thông tin!' });
    }
  }

  delete(id: number) {
    var _al = confirm('Bạn muốn xóa bản ghi này?');
    if (_al == true) {
      this.nguoiYeuCauService.delete(id).subscribe(
        (resp: any) => {
          this.getAllNYC();
        }
      );
    }
  }

  homeUrlNav() {
    this.router.navigate(['/home']);
  }

  getAllNYC() {
    this.loading = true;
    // Count
    this.nguoiYeuCauService.count(this.searchForm.controls.searchValue.value).subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.totalRecords = resp;
          this.pageNumber = 0;
          // console.log(this.totalRecords);
          // console.log(this.pageNumber);

          this.nguoiYeuCauService.findNYC(this.searchForm.controls.searchValue.value, this.pageSize, this.pageNumber).subscribe(
            (res: any) => {
              this.data = res;
              this.loading = false;
            }
          );
        }
      }
    );
  }

  showAddNYC() {
    this.infoFormGroup.reset();
    this.nguoiYeuCauFlag = true;
  }


  showEditNYC(id: number) {
    this.nguoiYeuCauFlag = true;
    this.nguoiYeuCauService.getNYCById(id).subscribe(
      (res: any) => {
        this.infoFormGroup.controls.id.setValue(id);
        this.infoFormGroup.controls.benthamgia.setValue(res.benthamgia);
        this.infoFormGroup.controls.diachi.setValue(res.diachi);
      }
    );
  }
}
